export enum AppNotificationType {
  NORMAL = 'normal',
  ERROR = 'error',
  SUCCESS = 'success',
}

export interface AppNotificationInterface {
  time: number;
  title?: string;
  message: string;
  silent?: boolean;
  type?: AppNotificationType;
  duration?: number;
  alwaysToast?: boolean;
}

export class AppNotification {
  static match(a: AppNotificationInterface, b: AppNotificationInterface): boolean {
    return (a.title === b.title &&
            a.time === b.time &&
            a.message === b.message &&
            a.silent === b.silent &&
            a.duration === b.duration &&
            a.alwaysToast === b.alwaysToast &&
            a.type === b.type);
  }
}
